import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Popup } from 'src/components/Popup/Popup';

class ConfirmationBox extends React.PureComponent {
    static propTypes = {
        message: PropTypes.string,
        onConfirm: PropTypes.func,
        onReject: PropTypes.func
    };

    confirm(e) {
        const { onConfirm } = this.props;

        if (e) {
            e.preventDefault();
        }

        if (onConfirm) {
            onConfirm();
        }
    }

    reject(e) {
        const { onReject } = this.props;

        if (e) {
            e.preventDefault();
        }

        if (onReject) {
            onReject();
        }
    }

    render() {
        const { message } = this.props;

        return (
            <Popup
                title="Confirm"
                className="confirmation-box"
                priority={ 10100 }
                overlayClose={ true }
                active={ true }
                onClose={ this.reject.bind(this)}
            >
                { message }
                <div className="buttons">
                    <a href="#" onClick={ this.confirm.bind(this)} className="btn btn-primary" data-test='confirm-button'>OK</a>
                    <a href="#" onClick={ this.reject.bind(this)} className="btn">Cancel</a>
                </div>
            </Popup>
        );
    }
}

export default ConfirmationBox;
